import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Dynamic Input",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-dynamic-input",
    args: {
        addText: "+ add another error number",
        initItems: 1,
        inputName: "errorNumber",
        maxItems: 6,
        minItems: 1,
    },
    argTypes: {
        addText: { control: "text" },
        initItems: { control: "number" },
        inputName: { control: "text" },
        maxItems: { control: "number" },
        minItems: { control: "number" },
    },
};

const Template = ({ addText, initItems, inputName, maxItems, minItems }) =>
    html`<ux-iws-dynamic-input
        add-text="${addText}"
        init-items="${initItems}"
        input-name="${inputName}"
        max-items="${maxItems}"
        min-items="${minItems}"
    ></ux-iws-dynamic-input>`;

export const Default = Template.bind({});
Default.args = {
    addText: "+ add another error number",
    initItems: 1,
    inputName: "errorNumber",
    maxItems: 6,
    minItems: 1,
};
